import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

// Create an HTTP link for all queries and mutations
const httpLink = createHttpLink({
  uri: 'https://zpjtdyijbngorl7srs7keo3efu.appsync-api.us-west-2.amazonaws.com/graphql',
});

const authLink = setContext((_, { headers }) => {
  const apiKey = 'da2-dysr52nqtvesdiv7hazatfxvia';
  return {
    headers: {
      ...headers,
      "x-api-key": apiKey
    }
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

export default client;


